module.exports = __webpack_public_path__ + "static/oblakoder-home-1-eea1c39e2f40fdd6062f7b2121c67e24.png";